import React from 'react';
import { DropdownWrapper } from 'components/formInputs/wrappers/dropdownWrapper';
import { DataColumn, List } from 'components/lists';
import { getFullDateInCustomTimezone } from 'utils/dateManagement';
import { Pagination } from 'components/lists/pagination';
import { Config } from 'configs';
import { getProgressStatusOptions } from '../enums';

export const ClosedOrdersList = ({
  orders,
  sort, onEditClicked, onSortOrders, onProgressStatusChange, isLoadingProgress,
  totalCount,
  currentPage,
  onChangePage,
}) => {
  return (
    <List
      source={orders}
      sort={sort}
      onRowClick={onEditClicked}
    >
      <DataColumn
        name="Date"
        dbColumnName="date_utc"
        render={(order) => {
          return getFullDateInCustomTimezone(order.date_utc, order.timezone);
        }}
        headerClass="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
        dataCellClass="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
        onSort={(sortOrder) => {
          onSortOrders('date_utc', 'date_utc', sortOrder);
        }}
      />
      <DataColumn
        name="Order"
        dbColumnName="number"
        render={(x) => {
          const providerOrderNumber = x.rkeeper_order_number;

          return <span>#{x.number}{providerOrderNumber ? <span className="text-xs text-gray-400"> (#{providerOrderNumber})</span> : ''}</span>;
        }}
        headerClass="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
        dataCellClass="px-6 py-4 text-left whitespace-nowrap text-sm text-gray-900"
        stackedColumns={[
          { name: 'Status', dbColumnName: 'order_status', class: 'mt-1 truncate text-gray-400 sm:hidden' },
        ]}
        onSort={(sortOrder) => {
          onSortOrders('number', 'number', sortOrder);
        }}
      />
      <DataColumn
        name="Status"
        dbColumnName="status"
        headerClass="hidden px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sm:table-cell"
        dataCellClass="hidden px-6 py-4 whitespace-nowrap text-sm text-gray-500 sm:table-cell"
        onSort={(sortOrder) => {
          onSortOrders('status', 'status', sortOrder);
        }}
      />
      {/* <DataColumn
        name="Progress"
        dbColumnName="progress_status"
        render={(x) => {
          return (
            <DropdownWrapper
              name="progress_status"
              options={getProgressStatusOptions({
                isDeliveryOrder: x.is_delivery,
                isTakeawayOrder: x.is_takeout,
                isProviderOrder: !!x.external_provider,
              })}
              responsiveClassName="col-span-6 lg:col-span-4"
              onChange={(e) => {
                onProgressStatusChange(x, e.target.value);
              }}
              defaultValue={x.progress_status}
              disabled={isLoadingProgress[x._id]}
            />
          );
        }}
        headerClass="hidden px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sm:table-cell"
        dataCellClass="hidden px-6 py-4 whitespace-nowrap text-sm text-gray-500 sm:table-cell"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      /> */}

      <DataColumn
        name="Amount"
        dbColumnName="order_sum"
        render={(x) => `${(x.order_sum || 0).toFixed(2)}`}
        headerClass="hidden px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider sm:table-cell"
        dataCellClass="hidden px-6 py-4 text-right whitespace-nowrap text-sm font-medium text-gray-900 sm:table-cell"
        onSort={(sortOrder) => {
          onSortOrders('order_sum', 'order_sum', sortOrder);
        }}
      />
      <DataColumn
        name="Paid"
        dbColumnName="paid"
        render={(x) => {
          let total = 0;

          if (x.payments) {
            x.payments.forEach((payment) => {
              total += (payment.amount || 0);
            });
          }

          return total.toFixed(2);
        }}
        headerClass="hidden px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider sm:table-cell"
        dataCellClass="hidden px-6 py-4 text-right whitespace-nowrap text-sm font-medium text-gray-900 sm:table-cell"
      />
      <DataColumn
        name="Tips"
        dbColumnName="tips"
        render={(x) => {
          let total = 0;

          if (x.payments) {
            x.payments.forEach((payment) => {
              total += (payment.tips || 0);
            });
          }

          return total.toFixed(2);
        }}
        headerClass="hidden px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider sm:table-cell"
        dataCellClass="hidden px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 sm:table-cell"
      />
      <Pagination
        pageSize={Config.DEFAULTS.PAGE_SIZE}
        totalCount={totalCount}
        currentPage={currentPage}
        onPageChanged={onChangePage}
      />
    </List>
  );
};
